import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

/** Sticky selection bar for workspace entity CSV export (not recipe-specific). */
export function ManufacturingEntityBulkBar({
  entityLabel,
  selectedCount,
  filteredCount,
  allFilteredSelected,
  busy,
  onSelectAllFiltered,
  onClear,
  onExportCsv,
  onExportAllFiltered,
  hint,
}: {
  entityLabel: string;
  selectedCount: number;
  filteredCount: number;
  allFilteredSelected: boolean;
  busy?: boolean;
  onSelectAllFiltered: () => void;
  onClear: () => void;
  onExportCsv: () => void;
  /** Export every filtered row even when none selected (shown when selection empty). */
  onExportAllFiltered?: () => void;
  hint?: string;
}) {
  if (selectedCount === 0 && !onExportAllFiltered) return null;

  if (selectedCount === 0 && onExportAllFiltered) {
    if (filteredCount === 0) return null;
    return (
      <div className="sticky top-0 z-10 rounded-2xl border border-gray-200 bg-white/90 px-3 py-2 shadow-sm backdrop-blur dark:border-zinc-700 dark:bg-zinc-900/80">
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            className={ghostBtnClass}
            onClick={onExportAllFiltered}
            disabled={busy}
          >
            Export all filtered CSV ({filteredCount})
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 z-10 rounded-2xl border border-indigo-200 bg-indigo-50/80 px-3 py-3 shadow-sm backdrop-blur dark:border-indigo-800 dark:bg-indigo-950/60">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
          {selectedCount} {entityLabel}
          {selectedCount === 1 ? "" : "s"} selected
        </div>
        <button type="button" className={ghostBtnClass} onClick={onExportCsv} disabled={busy}>
          Export CSV
        </button>
        {!allFilteredSelected && filteredCount > 0 ? (
          <button
            type="button"
            className={ghostBtnClass}
            onClick={onSelectAllFiltered}
            disabled={busy}
          >
            Select all filtered ({filteredCount})
          </button>
        ) : null}
        <button type="button" className={ghostBtnClass} onClick={onClear} disabled={busy}>
          Clear selection
        </button>
      </div>
      {hint ? (
        <p className="mt-2 text-[11px] text-indigo-800/80 dark:text-indigo-200/80">{hint}</p>
      ) : null}
    </div>
  );
}
